import { Component, Input, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { CustomValidators } from '@core-lib/classes';
import { IDevise } from '@core-lib/models';

@Component({
    selector: 'montant-picker-range',
    templateUrl: './montant-picker-range.component.html',
    styleUrls: [],
    standalone: false
})
export class MontantPickerRangeComponent implements OnInit {
	@Input() amountFromControl: FormControl<number | null>;
	@Input() amountToControl: FormControl<number | null>;
	@Input() amountFromLabel: string;
	@Input() amountToLabel: string;
	@Input() classCol: string;
	@Input() deviseList: IDevise[] = [];

	deviseInfo: IDevise;

	ngOnInit(): void {
		this.deviseInfo = this.deviseList.find(d => d.codeISO === 'EUR');
		this.setValidatorAmountDeLessOrEqualA();

		this.amountFromControl.valueChanges.subscribe(value => {
			if (value) {
				if (!this.amountToControl.value) {
					this.amountToControl.addValidators([Validators.required]);
					this.amountToControl.updateValueAndValidity({ emitEvent: false });
					this.amountToControl.markAsDirty();
				}
			} else {
				if (this.amountToControl.value) {
					this.amountFromControl.addValidators([Validators.required]);
					this.amountFromControl.updateValueAndValidity({ emitEvent: false });
					this.amountFromControl.markAsDirty();
				}
				this.amountToControl.removeValidators(Validators.required);
				this.amountToControl.updateValueAndValidity({ emitEvent: false });
			}
		});
		this.amountToControl.valueChanges.subscribe(value => {
			if (value) {
				if (!this.amountFromControl.value) {
					this.amountFromControl.addValidators([Validators.required]);
					this.amountFromControl.updateValueAndValidity({ emitEvent: false });
					this.amountFromControl.markAsDirty();
				}
			} else {
				if (this.amountFromControl.value) {
					this.amountToControl.addValidators([Validators.required]);
					this.amountToControl.updateValueAndValidity({ emitEvent: false });
					this.amountToControl.markAsDirty();
				}
				this.amountFromControl.removeValidators(Validators.required);
				this.amountFromControl.updateValueAndValidity({ emitEvent: false });
			}
		});
	}

	private setValidatorAmountDeLessOrEqualA(): void {
		this.amountFromControl.setValidators([CustomValidators.amountDeLessOrEqualA(this.amountToControl, true)]);
		this.amountToControl.setValidators([CustomValidators.amountDeLessOrEqualA(this.amountFromControl, false)]);
	}
}
